export const PORTAL_SCOPE_STORAGE_KEY = 'bc_portal_scope';
export const PORTAL_SCOPE_CHANGE_EVENT = 'bc-portal-scope-change';

const SCOPE_FIELDS = ['company_id', 'company_name', 'business_id', 'business_name', 'store_id', 'store_name'];

const normalizeScopeValue = (value) => {
  if (value === undefined || value === null || value === '') return undefined;
  return String(value);
};

export const normalizePortalScope = (scope = {}) =>
  SCOPE_FIELDS.reduce((result, field) => {
    const value = normalizeScopeValue(scope[field]);
    if (value !== undefined) result[field] = value;
    return result;
  }, {});

export const getPortalScope = () => {
  if (typeof window === 'undefined') return {};

  try {
    const storedValue = window.localStorage.getItem(PORTAL_SCOPE_STORAGE_KEY);
    if (!storedValue) return {};
    return normalizePortalScope(JSON.parse(storedValue));
  } catch (error) {
    return {};
  }
};

export const setPortalScope = (scope = {}, { notify = true } = {}) => {
  const normalizedScope = normalizePortalScope(scope);

  if (typeof window !== 'undefined') {
    window.localStorage.setItem(PORTAL_SCOPE_STORAGE_KEY, JSON.stringify(normalizedScope));
    if (notify) {
      window.dispatchEvent(new CustomEvent(PORTAL_SCOPE_CHANGE_EVENT, { detail: normalizedScope }));
    }
  }

  return normalizedScope;
};

export const clearPortalScope = ({ notify = true } = {}) => {
  if (typeof window !== 'undefined') {
    window.localStorage.removeItem(PORTAL_SCOPE_STORAGE_KEY);
    if (notify) {
      window.dispatchEvent(new CustomEvent(PORTAL_SCOPE_CHANGE_EVENT, { detail: {} }));
    }
  }
};

const isMissingScopeParam = (value) => value === undefined || value === null || value === '';

export const withPortalScope = (params = {}, options = {}) => {
  const { includeCompany = true, includeBusiness = true, includeStore = true, override = false } = options;
  const scope = getPortalScope();
  const nextParams = { ...(params || {}) };

  const applyScopeField = (field, includeField) => {
    if (!includeField) return;

    if (override) {
      if (scope[field]) {
        nextParams[field] = scope[field];
      } else {
        delete nextParams[field];
      }
      return;
    }

    if (scope[field] && isMissingScopeParam(nextParams[field])) {
      nextParams[field] = scope[field];
    }
  };

  applyScopeField('company_id', includeCompany);
  applyScopeField('business_id', includeBusiness);
  applyScopeField('store_id', includeStore);

  return nextParams;
};

export const withCompanyDocumentScope = (params = {}) => {
  const nextParams = withPortalScope(params, { includeBusiness: false, includeStore: false });
  ['business_id', 'store_id', 'business_ids', 'store_ids'].forEach(field => { delete nextParams[field]; });
  return nextParams;
};
